(() => {
  const form = document.getElementById('FluffsyWithdrawalForm');
  if (!form) return;
  const reviewButton = form.querySelector('[data-fluffsy-review]');
  if (!reviewButton) return;
  const fieldsPanel = form.querySelector('[data-fluffsy-withdrawal-fields]');
  const reviewPanel = form.querySelector('[data-fluffsy-review-panel]');
  const details = form.querySelector('[data-fluffsy-review-details]');
  const fields = Array.from(form.querySelectorAll('[data-fluffsy-receipt-field]'));
  const statement = form.querySelector('[data-fluffsy-statement]');
  const originalStatement = statement.value;
  const labelFor = (field) => form.querySelector('label[for="' + field.id + '"]').textContent.replace('*', '').trim();
  const populate = () => {
    form.querySelector('[data-fluffsy-full-name]').value = (fields[0].value.trim() + ' ' + fields[1].value.trim()).trim();
    statement.value = originalStatement + '\n\n' + fields.map((field) => labelFor(field) + ': ' + (field.value.trim() || details.dataset.emptyLabel)).join('\n');
  };
  reviewButton.type = 'button';
  reviewButton.textContent = reviewButton.dataset.reviewLabel;
  reviewButton.addEventListener('click', () => {
    if (!form.reportValidity()) return;
    populate();
    details.replaceChildren();
    fields.forEach((field) => {
      const term = document.createElement('dt');
      const value = document.createElement('dd');
      term.textContent = labelFor(field);
      value.textContent = field.value.trim() || details.dataset.emptyLabel;
      details.append(term, value);
    });
    fieldsPanel.hidden = true;
    reviewPanel.hidden = false;
    form.querySelector('[data-fluffsy-review-heading]').focus();
  });
  form.querySelector('[data-fluffsy-edit]').addEventListener('click', () => {
    reviewPanel.hidden = true;
    fieldsPanel.hidden = false;
    fields[0].focus();
  });
  form.addEventListener('submit', (event) => {
    if (reviewPanel.hidden) {
      event.preventDefault();
      reviewButton.click();
      return;
    }
    if (!form.reportValidity()) {
      event.preventDefault();
      reviewPanel.hidden = true;
      fieldsPanel.hidden = false;
      return;
    }
    populate();
    form.querySelector('[data-fluffsy-submitted-at]').value = new Date().toISOString();
  });
})();
